<template>
    <div class="contact">
        <newsHeader></newsHeader>
        <div class="map-wrapper">
            <div id="amap-container" class="map-container"></div>
        </div>
        <div class="view-width">
            <div class="contact-container">
                <div class="contact-from">
                    <div class="title">留下您的联系方式</div>
                    <div class="from-row">
                        <input type="text" v-model="form.name" maxlength="50" placeholder="姓名">
                    </div>
                    <div class="from-row">
                        <input type="text" v-model="form.email" maxlength="50" placeholder="邮箱">
                    </div>
                    <div class="from-row">
                        <input type="text" v-model="form.phone" maxlength="11" placeholder="电话">
                    </div>
                    <div class="from-row">
                        <input type="text" v-model="form.weChat" maxlength="50" placeholder="微信">
                    </div>
                    <div class="from-row">
                        <input type="text" v-model="form.remarks" maxlength="50" placeholder="备注">
                    </div>
                    <div class="from-row btn-cont">
                        <div class="btn" @click="submit">确定</div>
                    </div>
                </div>
                <div class="contact-info">
                    <div class="contact-info-title">医智诺竭诚为您服务</div>
                    <div class="contact-info-item">
                        <div>访问我们</div>
                        <div>陕西省西安市高新区天谷八路156号西安软件新城研发基地二期C2栋14层1401室</div>
                    </div>
                    <div class="contact-info-item">
                        <div>工作时间</div>
                        <div>每周一至周五（法定节假日除外）</div>
                        <div>8:30 AM ~ 18:00 PM</div>
                    </div>
                </div>
            </div>
        </div>
        <My-new-footer></My-new-footer>
    </div>
</template>
<script>
import newsHeader from '@/views/newsHeader/index'
export default {
    components: {
        newsHeader
    },
    data() {
        return {
            center: { lng: 108.835123, lat: 34.206827 },
            zoom: 18,
            form: {
                name: '',
                email: '',
                phone: '',
                weChat: '',
                remarks: '',
            },
            map: null,
        }
    },
    mounted() {
        this.initAMap();
    },
    beforeDestroy() {
        if (this.map) {
            this.map.destroy();
        }
    },
    methods: {
        submit() {
            const form = this.form;
            if (form.name || form.email || form.phone || form.weChat || form.remarks) {
                this.$message({
                    message: '提交成功!',
                    type: 'success',
                    offset: 100
                });

                this.form = {
                    name: '',
                    email: '',
                    phone: '',
                    weChat: '',
                    remarks: '',
                }
            }
        },

        initAMap() {
            this.map = new AMap.Map('amap-container', {
                center: [108.835123,34.206827],
                zoom: 16,
                resizeEnable: true,
                scrollWheel: true
            });
            const marker = new AMap.Marker({
                position: [108.835123,34.206827],
                title: '陕西医智诺信息科技有限公司'
            });
            const infoWindow = new AMap.InfoWindow({
                content: `
                    <div style="padding: 10px; color: #343478; font-size: 16px;">
                        <div><strong>地点：陕西医智诺信息科技有限公司</strong></div>
                        <div>地址：陕西省西安市高新区天谷八路156号西安软件新城研发基地二期C2栋14层1401室</div>
                    </div>
                `,
                offset: new AMap.Pixel(0, -30)
            });
            marker.on('click', () => {
                infoWindow.open(this.map, marker.getPosition());
            });
            this.map.add(marker);
            infoWindow.open(this.map, marker.getPosition());
        },
        getClickInfo(e) {
            this.center.lng = e.lnglat.lng;
            this.center.lat = e.lnglat.lat;
        }
    }
}
</script>
<style lang="scss" scoped>
.contact {
    background: #F9F9FD;
    font-family: SourceHanSansCN-Regular;
    padding-top: 74px;

    input {
        background: none;
        outline: none;
        border: none;
    }

    .map-container {
        width: 100%;
        height: 760px;
    }

    .contact-container {
        padding: 0 70px;
        padding-bottom: 50px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;

        .contact-from {
            padding: 100px 97px;
            background: #FFFFFF;
            box-shadow: 0px 40px 100px 0px rgba(0, 0, 0, 0.15);
            position: relative;
            top: -150px;
            z-index: 1000;

            .title {
                font-size: 30px;
                color: #0A0D10;
                font-weight: 400;
                line-height: 45px;
                margin-bottom: 20px;
            }

            .from-row {
                width: 458px;

                input {
                    width: 100%;
                    border-bottom: 1px solid #C7CCDA;
                    font-size: 18px;
                    color: #0A0D10;
                    line-height: 24px;
                    padding-top: 32px;
                    padding-bottom: 16px;
                }

                input:focus {
                    border-bottom: 1px solid #6A7581;
                }

                input::placeholder {
                    color: #A7AEC2;
                }
            }

            .btn-cont {
                margin-top: 47px;
            }

            .btn {
                display: inline-block;
                font-size: 20px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 30px;
                background: #0D6EFD;
                border-radius: 8px;
                padding: 15px 40px;
                cursor: pointer;
            }

        }

        .contact-info {
            flex: 1;
            font-size: 16px;
            font-weight: 400;
            color: #0A0D10;
            margin-left: 128px;

            .contact-info-title {
                padding-top: 170px;
                font-size: 30px;
            }

            .contact-info-item {
                padding-top: 24px;
                line-height: 24px;

                >div:nth-child(1) {
                    font-size: 16px;
                    color: #A7AEC2;
                    margin-bottom: 5px;
                }
            }
        }
    }
}
</style>